var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 26@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "30 0 55.9807621 15 55.9807621 45 30 60 4.01923789 45 4.01923789 15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-32.5%",
    y: "-32.5%",
    width: "185.0%",
    height: "185.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.622987115   0 0 0 0 0.642494553   0 0 0 0 0.759539176  0 0 0 0.4 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barlow-Marshall---Home-V2",
    transform: "translate(-951.000000, -2453.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(960.000000, 2462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon-Copy-23"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-checkmark-1379283",
    transform: "translate(18.000000, 18.000000)",
    fill: "#2283FB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3676606,7.299522 L11.001173,13.8284216 L7.540444,10.8552287 C7.28887443,10.6423283 6.94039825,10.5767251 6.62608857,10.6833839 C6.31178997,10.7898313 6.07969032,11.0524663 6.01673978,11.3720308 C5.95401075,11.6915898 6.070168,12.0196114 6.32173535,12.2327447 L10.4460808,15.7733359 C10.6262662,15.9284616 10.860963,16.0093049 11.1006158,15.9991466 C11.3405012,15.9889884 11.5671962,15.8884625 11.7328899,15.718736 L18.7256711,8.55542093 C18.9036914,8.38230838 19.0025472,8.14612811 19,7.90063476 C18.9971381,7.65514684 18.8933085,7.42107948 18.7118273,7.25159139 C18.5301302,7.08207621 18.2863464,6.99170857 18.0354192,7.00059906 C17.784719,7.00969921 17.548289,7.11741603 17.3797767,7.29941906 L17.3676606,7.299522 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C8.81739967,0 5.76524188,1.26420477 3.5146409,3.5146409 C1.26420477,5.76529682 0,8.81761945 0,12 C0,15.1823805 1.26420477,18.2347581 3.5146409,20.4853591 C5.76529682,22.7357952 8.81761945,24 12,24 C15.1823805,24 18.2347581,22.7357952 20.4853591,20.4853591 C22.7357952,18.2347032 24,15.1823805 24,12 C24,8.81761945 22.7357952,5.76524188 20.4853591,3.5146409 C18.2347032,1.26420477 15.1823805,0 12,0 Z M12,22.1543534 C9.30697131,22.1543534 6.72427482,21.0843838 4.8201653,19.1801644 C2.91605577,17.275945 1.84597633,14.6932485 1.84597633,12.0003297 C1.84597633,9.30741088 2.91594588,6.7246045 4.8201653,4.82049497 C6.72438472,2.91638545 9.30708121,1.84630601 12,1.84630601 C14.6929188,1.84630601 17.2757252,2.91627556 19.1798347,4.82049497 C21.0839442,6.72471439 22.1540237,9.30741088 22.1540237,12.0003297 C22.1540237,14.6932485 21.0840541,17.2760549 19.1798347,19.1801644 C17.2756153,21.0842739 14.6929188,22.1543534 12,22.1543534 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimple);
export default __webpack_public_path__ + "static/media/simple.44b965cc0ee1c1e148d884ea7d186db9.svg";
export { ForwardRef as ReactComponent };